import { request99 } from "@/utils/request";

//  旧版运营平台学习云埋点
const yklFirst = {
  yklFirstEvente(data) {
    return request99({
      method: "POST",
      url: "/api/userEvent/yklNewEvent/yklFirstEvent",
      data
    });
  },
  // 第二层表格
  yklTwoEvent(data) {
    return request99({
      method: "POST",
      url: "/api/userEvent/yklNewEvent/yklTwoEvent",
      data
    });
  },
    // 第三层表格
    yklEventDetail(data) {
        return request99({
          method: "POST",
          url: "/api/userEvent/yklNewEvent/yklEventDetail",
          data
        });
      }
};

export default yklFirst;
